import { useInfiniteQuery, useQuery } from "react-query";
import { supabase } from "../../../config/supabaseClient";

/**
 * Load content
 */
export function useLoadRenderComponent(user_id: string, unique_id: any,from?:any) {
  async function getComponent({ pageParam = 1 }) {
    let data: any, error: any;
   if(user_id && unique_id){
    if(from === "embed-search"){
    const { data: uniqueIdData, error: uniqueIdError } = await supabase
      .from("embed_components")
      .select("*")
      .eq("user_id", user_id)
      .eq("unique_id", unique_id);

    const { data: routeNameData, error: routeNameError } = await supabase
      .from("embed_components")
      .select("*")
      .eq("user_id", user_id)
      .eq("route_name", unique_id);

      data = [...(uniqueIdData || []), ...(routeNameData || [])];;
    }else{
      const { data: uniqueIdData, error: uniqueIdError } = await supabase
      .from("stayuptodate_components")
      .select("*")
      .eq("user_id", user_id)
      .eq("unique_id", unique_id);

    const { data: routeNameData, error: routeNameError } = await supabase
      .from("stayuptodate_components")
      .select("*")
      .eq("user_id", user_id)
      .eq("route_name", unique_id);
       
      const { data: uniqueIdEmbedData, error: uniqueIdEmbedError } = await supabase
      .from("embed_components")
      .select("*")
      .eq("user_id", user_id)
      .eq("unique_id", unique_id);

    const { data: routeNameEmbedData, error: routeNameEmbedError } = await supabase
      .from("embed_components")
      .select("*")
      .eq("user_id", user_id)
      .eq("route_name", unique_id);

     data = [...(uniqueIdData || []), ...(routeNameData || []), ...(uniqueIdEmbedData || []), ...(routeNameEmbedData || [])];

    }

    if (data && data.length >= 0 && Array.isArray(data)) {
      return data[0];
    } else if (error) {
      throw new Error(error.message);
    } else {
      throw new Error("Failed to fetch posts");
    }
  }}

  return useQuery(
    ["getComponent", user_id, unique_id, from],
    getComponent,
    {
      enabled: Boolean(user_id) && Boolean(unique_id) && user_id !== 'undefined' && unique_id !== 'undefined',
    }
  );
}
